import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useCallback } from 'react';
import { Button as Button$2 } from '@chakra-ui/react';
import { withTooltip } from '../../hoc/with-tooltip.js';
var _excluded = ["data", "href", "onClick"];
var Button = /*#__PURE__*/React.forwardRef(function (props, ref) {
  props.data;
  var href = props.href,
    onClick = props.onClick,
    rest = _objectWithoutProperties(props, _excluded);
  var clickHandler = useCallback(function (e) {
    if (href) {
      window.location.assign(href);
    }
    onClick === null || onClick === undefined || onClick(e);
  }, [href, onClick]);

  /**
   * DOM
   */
  return /*#__PURE__*/React.createElement(Button$2, _extends({
    "data-object-type": "button",
    ref: ref,
    onClick: clickHandler,
    "data-action-target": "button"
  }, rest), props.children);
});
Button.displayName = 'Button';
var Button$1 = withTooltip('CoreButton')(Button);
export { Button, Button$1 as default };